<template>
    <form @submit.prevent="handleSubmit(item)">

        <div :class="{ 'form-group': true, 'has-error': (errors && errors.name) }">
            <label for="_name" class="control-label">Name</label>
            <input v-model="item.name" type="text" placeholder="the name of the channel" required="true" id="_name"
                   class="form-control"/>
            <span v-if="errors && errors.name" class="help-block" id="_name_helpBlock">{{ errors.name }}</span>
        </div>
        <!--<div :class="{ 'form-group': true, 'has-error': (errors && errors.domain) }">
            <label for="_domain" class="control-label">Domain</label>
            <input v-model="item.domain" type="text" placeholder="domain of the channel" id="_domain"
                   class="form-control"/>
            <span v-if="errors && errors.domain" class="help-block" id="_domain_helpBlock">{{ errors.domain }}</span>
            <div class="help">Asterisk ("*") ist als Wildcard Zeichen erlaubt. Trennzeichen für mehrere Domains ist Komma (","). <br/> Beispiel: <i>https://*.bnamic.com,https://www.brandnamic.com</i>  </div>
        </div>-->
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.description) }">
            <label for="_description" class="control-label">Description</label>
            <input v-model="item.description" type="text" placeholder="" id="_description" class="form-control"/>
            <span v-if="errors && errors.description" class="help-block"
                  id="_description_helpBlock">{{ errors.description }}</span>
        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.domain) }">
            <label for="_organization" class="control-label">Organization</label>
            <select v-model="item.organization" id="_organization">
                <option v-for="(value, key, index) in organizations" v-bind:value="value['@id']">{{
                    getTranslation(value,'de','legalName')}}
                </option>
            </select>
            <span v-if="errors && errors.organization" class="help-block" id="_organization_helpBlock">{{ errors.organization }}</span>
        </div>

        <div class="card bn-tabs">
            <ul class="nav nav-tabs" id="typeTab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="text_locks-tab" data-toggle="tab" href="#text_blocks" role="tab"
                       aria-controls="home" aria-selected="true">Text Blocks</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="cookies-tab" data-toggle="tab" href="#cookies" role="tab"
                       aria-controls="profile" aria-selected="false">Cookies</a>
                </li>
            </ul>
            <div class="tab-content" id="typeTabContent">
                <div v-if="textBlocks && item.textBlocks" class="tab-pane fade show active" id="text_blocks" role="tabpanel" aria-labelledby="text_blocks-tab">
                    <div class="container dndlist">
                        <div class="row">
                            <div class="dndlistavailable col">
                                <div class="card">
                                    <div class="card-header">Available Text Blocks</div>
                                    <draggable class="draggabletb custom-select list-group" v-model="availableTextBlocks" group="textBlocks" @change="selectedTextBlocksChanged">
                                        <div
                                                class="list-group-item"
                                                v-for="(value) in availableTextBlocks"
                                                :key="value.id"
                                                v-bind:value="value.id"
                                        >
                                            {{ value.name }}
                                        </div>
                                    </draggable>
                                </div>
                            </div>

                            <div class="dndlistselected col">
                                <div class="card">
                                    <div class="card-header">Selected Text Blocks</div>
                                    <draggable class="draggabletb list-group" v-model="selectedTextBlocks" group="textBlocks" @change="selectedTextBlocksChanged">
                                   <div
                                            class="list-group-item"
                                            v-for="(value) in selectedTextBlocks"
                                            :key="value.id"
                                            v-bind:value="value.id"
                                    >{{value.name}}
                                    </div>
                                </draggable>
                                </div>
                            </div>

                        </div>

                    </div>

                </div>

                <div role="tabpanel" class="tab-pane fade" aria-labelledby="cookies-tab" id="cookies">

                    <div v-if="cookies">
                        <div class="container dndlist">
                            <div class="row">
                                <div class="dndlistavailable col">
                                    <div class="card">

                                        <div class="card-header">Available Cookies</div>
                                        <select v-model="availableCookiesSelected" class="custom-select list-group"
                                                multiple>
                                            <option v-for="(value) in cookies"
                                                    v-if="!item.cookies || item.cookies.indexOf(value['@id'])==-1"
                                                    v-bind:value="value"
                                            >{{value['name']}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="dndlistbuttons ">
                                    <span class="btn btn-sm oi oi-caret-right"
                                          v-bind:class="{ disabled: availableCookiesSelected.length == 0 }"
                                          title="icon name" aria-hidden="true" v-on:click="addSelectedCookies"/>
                                    <span class="btn btn-sm oi oi-media-skip-forward" title="icon name"
                                          aria-hidden="true" v-on:click="addAllCookies"/>
                                    <span class="btn btn-sm oi oi-media-skip-backward" title="icon name"
                                          aria-hidden="true" v-on:click="removeAllCookies"/>
                                    <span class="btn btn-sm oi oi-caret-left"
                                          v-bind:class="{ disabled: selectedCookiesSelected.length == 0 }"
                                          title="icon name" aria-hidden="true" v-on:click="removeSelectedCookies"/>
                                </div>
                                <div class="dndlistselected col">
                                    <div class="card">
                                        <div class="card-header">Selected Cookies</div>

                                        <select v-model="selectedCookiesSelected" class="custom-select list-group"
                                                multiple>
                                            <option v-for="(value) in cookies"
                                                    v-if="item.cookies && item.cookies.indexOf(value['@id'])!==-1"
                                                    v-bind:value="value"
                                            >{{value['name']}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>



            </div>

        </div>
        <div :class="{ 'form-group': true, 'has-error': (errors && errors.description) }">
            <label :for="'preview_button'" class="control-label"> </label>
            <button type="button" class="btn btn-sm" data-toggle="modal" data-target="#previewDialogModal">
                Preview...
            </button>
        </div>

        <div class="modal fade" id="previewDialogModal" tabindex="-1" role="dialog"
             aria-labelledby="previewDialogModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="previewDialogModalLabel">Preview</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <select>
                            <option v-for="(value, key, index) in languages" :value="key">{{ value }}</option>

                        </select>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                        <button type="button" class="btn btn-primary" v-on:click.stop="doPreview">Preview</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="previewModal" tabindex="-1" role="dialog" aria-labelledby="previewModalLabel"
             aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="previewModalLabel">Preview</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" style="overflow-y: scroll; height: 800px">
                        <div v-for="(value) in previewData.textBlocksHtml">
                            <div v-html="value"></div>
                            <hr/>
                        </div>

                        <div v-html="previewData.cookiesHtml"></div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>

        <button type="submit" class="btn btn-primary">Submit</button>

    </form>

</template>
<style>
    .dndlist select {
        height: 300px !important;
        overflow: auto;
    }

    .dndlistavailable, .dndlistselected {
        float: left;
        margin-top: 10px;

    }

    .dnlist .card {
        width: 48%;
    }

    .dndlistbuttons {
        float: left;
        width: 4%;
        padding-top: 80px;
        text-align: center;
    }

    .dndlistbuttons .btn {

        display: block;
        width: 30px;
        margin-top: 10px;
    }

    .dndlistbuttons .disabled {
        color: gray;
    }
    .draggabletb{
        overflow: auto;
        height:300px;
        padding:0;
    }
    .list-group-item{
        padding: 0 1.25rem;
    }


</style>

<script>
    import {API_LANGUAGES} from '../../config/languages';
    import {API_HOST, API_PATH} from '../../config/_entrypoint';
    import draggable from 'vuedraggable';

    const API_URL = API_HOST + API_PATH;

    export default {
        props: {
            handleSubmit: {
                type: Function,
                required: true,
            },
            values: {
                type: Object,
                required: true
            },
            errors: {
                type: Object
            },
            initialValues: {
                type: Object
            }
        },
        components: {
            draggable,
        },
        computed: {
            item() {
                let values = this.initialValues ? this.initialValues : this.values;
                if (typeof values.channelTextBlocks === 'undefined') this.$set(values, 'channelTextBlocks', []);
                if (typeof values.textBlocks === 'undefined') this.$set(values, 'textBlocks', []);
                if (typeof values.cookies === 'undefined') this.$set(values, 'cookies', []);

                return values;
            },
            selectedTextBlocks: {
                get(){
                    let data=[];
                    console.log(this.item.textBlocks);
                    for(let i in this.item.textBlocks){
                        let id=this.item.textBlocks[i];
                        let textblock=this.getTextBlockById(id);
                        if (textblock!==false){
                            data.push({name:textblock.name,id:textblock['@id']})
                        }
                    }
                    return data;

                    //return this.$store.state.selectedTextBlocks
                },
                set(value){
                    console.log(value);
                    let data=[];
                    for(let i in value){
                        data.push(value[i].id);
                    }
                    this.item.textBlocks=data;
                    console.log(this.item.textBlocks);
                }
            },
            availableTextBlocks: {
                get(){
                    let data=[];
                    for (let i in this.$store.state.textblock.list.items) {
                        let textblock=this.$store.state.textblock.list.items[i];
                        var found = this.item.textBlocks.find(function(ele){
                           return ele === textblock['@id'];
                        });
                        if (typeof found == 'undefined'){
                            data.push({name:textblock.name,id:textblock['@id']})
                        }
                    }
                    return data;
                },
                set(value){
                    console.log(value);

                }
            }
        },
        watch: {
            item: function (newItem, oldItem) {
                //console.log(newItem.cookies);
            }
        },
        data: function () {

            return {
                languages: API_LANGUAGES,
                cookies: this.$store.getters['cookies/list/items'],
                textBlocks: this.$store.getters['textBlocks/list/items'],
                organizations: this.$store.getters['organizations/list/items'],
                cookiePresets: this.$store.getters['cookiePresets/list/items'],
                previewData: {},
                availableCookiesSelected: [],
                selectedCookiesSelected: [],
                availableTextBlocksxxxxxx: [{ name: "Textblock 1", id: 1 },
                    { name: "Textblock 2", id: 2 },
                    { name: "Textblock 3", id: 3 },
                    { name: "Textblock 4", id: 4 }],
                selectedTextBlocksxxxxx: [{ name: "Textblock 5", id: 5 },
                    { name: "Textblock 6", id: 6 },
                    { name: "Textblock 7", id: 7 }]


            }
        },

        mounted() {
            this.loadData();

        },
        methods: {
            loadData() {
                this.$store.subscribe(mutuation => {
                    if (mutuation.type === "organization/list/ORGANIZATION_LIST_SUCCESS") {
                        this.organizations = Object.assign({}, this.$store.getters['organization/list/items']);
                    }
                    if (mutuation.type === "textblock/list/TEXTBLOCK_LIST_SUCCESS") {
                        this.textBlocks = this.$store.getters['textblock/list/items'];
                    }
                    if (mutuation.type === "cookie/list/COOKIE_LIST_SUCCESS") {
                        this.cookies = Object.assign({}, this.$store.getters['cookie/list/items']);

                    }
                    if (mutuation.type === "cookiepreset/list/COOKIEPRESET_LIST_SUCCESS") {
                        this.cookiePresets = Object.assign({}, this.$store.getters['cookiepreset/list/items']);
                    }
                });

                this.$store.dispatch('organization/list/getItems', '/organizations?pagination=false');
                this.$store.dispatch('textblock/list/getItems', '/text_blocks?order[name]=ASC&pagination=false');
                this.$store.dispatch('cookie/list/getItems', '/cookies?order[name]=ASC&pagination=false');
                this.$store.dispatch('cookiepreset/list/getItems', '/cookiepresets?pagination=false');


            },
            getTranslation(value, locale, field) {

                if (value.translations) {
                    for (let index in value.translations) {
                        let val = value.translations[index];
                        if (val.locale === locale) {
                            return val[field];
                        }
                    }
                }


            },
            doPreview(event) {
                $('#previewDialogModal').modal('hide');
                fetch(API_URL + 'render/channels/' + $('#previewDialogModal select').val() + "/" + this.item['id'], {
                    method: 'GET',
                    accept: 'application/json'
                })
                    .then(response => response.json()).then(response => {
                    if (response['hydra:member']) {
                        this.previewData = response['hydra:member'][0];
                        $('#previewModal').modal('show');
                    }
                    if (response['@type'] === 'hydra:Error') alert(response['hydra:description']);

                });


            },
            doAddCookiePresets(event) {
                let selectedCookiePreset = event.target.value;
                for (let index in this.cookiePresets) {
                    if (this.cookiePresets[index]['@id'] === selectedCookiePreset) {
                        for (let ii in this.cookiePresets[index]['cookies']) {
                            if (this.item.cookies.indexOf(this.cookiePresets[index]['cookies'][ii]) === -1) this.item.cookies.push(this.cookiePresets[index]['cookies'][ii]);
                        }

                    }
                }


            },
            addSelectedCookies: function () {
                if (typeof this.item.cookies === 'undefined') this.item.cookies = [];
                for (let i in this.availableCookiesSelected) {
                    if (typeof this.availableCookiesSelected[i]['@id'] !== 'undefined') {
                        //this.item.cookies.push(this.availableCookiesSelected[i]['@id']);
                        this.$set(this.item.cookies, this.item.cookies.length, this.availableCookiesSelected[i]['@id'])
                    }
                }
            },
            removeSelectedCookies: function () {
                for (let i in this.selectedCookiesSelected) {
                    if (typeof this.selectedCookiesSelected[i]['@id'] !== 'undefined') {
                        this.item.cookies.splice(this.item.cookies.indexOf(this.selectedCookiesSelected[i]['@id']), 1);
                    }
                }
            },
            addAllCookies: function () {
                for (let i in this.cookies) {
                    if (this.cookies.hasOwnProperty(i)) {
                        if (this.item.cookies.indexOf(this.cookies[i]['@id']) === -1) {
                            this.item.cookies.push(this.cookies[i]['@id']);
                        }
                    }
                }
            },
            removeAllCookies: function () {
                this.item.cookies = [];

            },
            getTextBlockById: function(id){
                console.log(id,this.$store.state.textblock.list.items);
                for (let i in this.$store.state.textblock.list.items) {

                    if (this.$store.state.textblock.list.items[i]['@id']===id) {
                        console.log(id, i, this.$store.state.textblock.list.items[i]);
                        return this.$store.state.textblock.list.items[i];

                    }
                }
                return false;
            },
            selectedTextBlocksChanged: function(evt){
                console.log(evt);
                console.log(this.availableTextBlocks);
                console.log(this.selectedTextBlocks);

            }

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/channel/Form.vue